import { makeStyles, styled } from '@material-ui/core/styles';
import { DSTheme } from '../../../styles/themes/types';

export const SectionRow = styled('div')(({ theme }: { theme: DSTheme }) => ({
  display: 'flex',
  flexDirection: 'row',

  [theme.breakpoints.up('md')]: {
    minWidth: '564px',
  },
}));

export const GridRow = styled('div')(({ theme }: { theme: DSTheme }) => ({
  display: 'grid',
  gridGap: '32px',
  width: '100%',

  gridTemplateColumns: '248px 248px',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '266px 266px',
  },
}));

export const UploadRow = styled('div')(({ theme }: { theme: DSTheme }) => ({
  display: 'grid',
  gridGap: '32px',

  gridTemplateColumns: '248px 248px',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '432px 432px',
  },
}));

export const ExpandContent = styled('div')(({ theme }: { theme: DSTheme }) => ({
  display: 'grid',
  rowGap: '42px',
}));

export const UploadCard = styled('div')(({ theme }: { theme: DSTheme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  justifyContent: 'space-between',
  borderRadius: '16px',
  backgroundColor: theme.palette.background.elevation2,
  width: '184px',
  height: '214px',
  padding: '32px',
  marginTop: '8px',
  outline: 'none',

  [theme.breakpoints.up('md')]: {
    width: '366px',
  },

  '&.dashed': {
    border: '1px dashed',
    borderColor: theme.palette.text.primary,
  },
}));

export const ButtonRow = styled('div')(() => ({
  display: 'grid',
  gridGap: '24px',

  gridTemplateColumns: '80px 80px 80px',
}));

export const useRatingStyles = makeStyles((theme) => ({
  ratingHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '-1rem',
    marginBottom: '-1rem',
  },

  ratingRow: {
    width: '95%',
    marginBottom: '32px',
  },
  ratingButtonsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '32px',
  },
  ratingRadioGroup: {
    display: 'grid !important',
    gridGap: '55px',
    height: '100%',
    width: '175px',

    [theme.breakpoints.up('md')]: {
      gridGap: '24px',
    },
  },
  descriptionWrapper: {
    display: 'grid',
    gridGap: '24px',
    maxWidth: '369px',
    marginLeft: '18px',

    [theme.breakpoints.up('md')]: {
      maxWidth: '737px',
    },
  },
  certificate: {
    '& .certificate-status': {
      minHeight: 'auto',
      padding: 0,
      marginTop: 0,

      '& .certificate-status-rating-bottom-wrapper': {
        marginTop: '-3.6rem',
      },
    },
  },
}));
